import React from 'react';

import { useClaim } from '~/components/ClaimContainer';
import { useClaimSearch } from '~/components/SystemConfiguration/Integrations/ClaimSearch/hooks/useClaimSearch';

import ClaimAlerts from '../ClaimAlerts';

type ClaimAlertsWrapperProps = {
  displayName?: string;
};

const ClaimAlertsWrapper = ({ displayName = 'Claim Alerts' }: ClaimAlertsWrapperProps) => {
  const { claim } = useClaim({ claimRequired: true });
  const { isEnabled, getClaimSearchScoreRoute } = useClaimSearch();

  return isEnabled ? (
    <ClaimAlerts claimSearchScoreRoute={getClaimSearchScoreRoute(claim.id)} claim={claim} displayName={displayName} />
  ) : null;
};

export default ClaimAlertsWrapper;
